import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-01679402")

_pushScopeId("data-v-01679402")
const _hoisted_1 = { class: "select-day-template" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Apply ")
const _hoisted_4 = { class: "select is-size-6 ml-1 mr-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" template: ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_day_template_preview = _resolveComponent("day-template-preview")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("select", {
          class: "select-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedId = $event))
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.user.dayTemplates, ({ id, name }) => {
            return (_openBlock(), _createBlock("option", {
              key: id,
              value: id
            }, _toDisplayString(name), 9, ["value"]))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedId]
        ])
      ]),
      _hoisted_5,
      _createVNode("button", {
        type: "submit",
        class: "button is-outlined is-success ml-2",
        textContent: _toDisplayString(_ctx.submitText),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, null, 8, ["textContent"])
    ]),
    _createVNode(_component_day_template_preview, { dayTemplate: _ctx.selectedDayTemplate }, null, 8, ["dayTemplate"])
  ]))
})